
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuLink,
  NavigationMenuItem,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { Book, MessageSquare } from "lucide-react";

const NavigationLinks = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <Link to="/learn">
            <NavigationMenuLink className="group inline-flex h-10 w-max items-center justify-center gap-1 rounded-md bg-transparent px-4 text-sm font-semibold transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50">
              <Book className="h-4 w-4" />
              Learn
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <Link to="/coaching">
            <NavigationMenuLink className="group inline-flex h-10 w-max items-center justify-center gap-1 rounded-md bg-transparent px-4 text-sm font-semibold transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50">
              <MessageSquare className="h-4 w-4" />
              Coaching
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>


      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default NavigationLinks;
